import toggleBoolStringAttr from 'views/utils/toggleBoolStringAttribute'
import {
  ARIA_HIDDEN,
  OVERLAY_SELECTOR,
  MENUBAR_OVERLAY_SELECTOR,
  BODY_HOVER_CLASS
} from './consts'

const registerListeners = (elements, overlay) => {
  const isHoverActive = () => document.body.classList.contains(BODY_HOVER_CLASS)

  return elements.map(element => {
    const hide = () => {
      ;[element, overlay].forEach(elem =>
        toggleBoolStringAttr(elem, ARIA_HIDDEN, true)
      )
      overlay.removeEventListener('click', hide)
    }
    const show = () => {
      ;[element, overlay].forEach(elem =>
        toggleBoolStringAttr(elem, ARIA_HIDDEN, false)
      )
      overlay.addEventListener('click', hide)
    }

    element.addEventListener('mouseenter', () => {
      if (!isHoverActive()) {
        return
      }
      show()
    })
    element.addEventListener('mouseleave', () => {
      if (!isHoverActive()) {
        return
      }
      hide()
    })
    element.addEventListener('click', () => {
      if (isHoverActive()) {
        return
      }
      if (element.getAttribute(ARIA_HIDDEN) === 'true') {
        show()
      } else {
        hide()
      }
    })

    return element
  })
}

export default () => {
  const headerFlyoutElements = [
    ...document.querySelectorAll('[data-clientside-hook~="headerFlyout"]')
  ]
  const headerOverlay = document.querySelector(OVERLAY_SELECTOR)

  const menubarFlyoutElements = [
    ...document.querySelectorAll('[data-clientside-hook~="menubarFlyout"]')
  ]
  const menubarOverlay = document.querySelector(MENUBAR_OVERLAY_SELECTOR)

  return [
    registerListeners(headerFlyoutElements, headerOverlay),
    registerListeners(menubarFlyoutElements, menubarOverlay)
  ]
}
